export enum RETURNS_PORTAL_TRANSLATION_KEYS {
    FIRST_PAGE_CONTENT = 'FIRST_PAGE_CONTENT',
    WHICH_ITEMS_YOU_WANT_TO_RETURN = 'WHICH_ITEMS_YOU_WANT_TO_RETURN',
    CHOOSE_ANY_ITEMS = 'CHOOSE_ANY_ITEMS',
    SELECT_AMOUNT = 'SELECT_AMOUNT',
    SELECT_ACTION = 'SELECT_ACTION',
    ITEM_ACTION_EXCHANGE_REPLACE_DESCRIPTION = 'ITEM_ACTION_EXCHANGE_REPLACE_DESCRIPTION',
    ITEM_ACTION_EXCHANGE_DESCRIPTION = 'ITEM_ACTION_EXCHANGE_DESCRIPTION',
    ITEM_ACTION_PRODUCT_EXCHANGE_DESCRIPTION = 'ITEM_ACTION_PRODUCT_EXCHANGE_DESCRIPTION',
    ITEM_ACTION_MANUAL_EXCHANGE_DESCRIPTION = 'ITEM_ACTION_MANUAL_EXCHANGE_DESCRIPTION',
    ITEM_ACTION_RETURN_DESCRIPTION = 'ITEM_ACTION_RETURN_DESCRIPTION',
    GROUP_ITEM_ACTION_SAME = 'GROUP_ITEM_ACTION_SAME',
    GROUP_ITEM_ACTION_SEPARATE = 'GROUP_ITEM_ACTION_SEPARATE',
    RETURNING_A_GIFT = 'RETURNING_A_GIFT',
    POLICY_CONFIRMATION_TITLE = 'POLICY_CONFIRMATION_TITLE',
    POLICY_CONFIRMATION_DESCRIPTION = 'POLICY_CONFIRMATION_DESCRIPTION',
    POLICY_CONFIRMATION_INSTRUCTIONS = 'POLICY_CONFIRMATION_INSTRUCTIONS',
    POLICY_CONFIRMATION_STATEMENTS = 'POLICY_CONFIRMATION_STATEMENTS',
    RETURN_GIFTS = 'RETURN_GIFTS',
    ORDER_DETAILS = 'ORDER_DETAILS',
    ORDER_DETAILS_CONTENT = 'ORDER_DETAILS_CONTENT',
    GIFT_ORDER_NUMBER_FIELD = 'GIFT_ORDER_NUMBER_FIELD',
    GIFT_EZP_FIELD = 'GIFT_EZP_FIELD',
    GIFT_RECIPIENTS_INFORMATION = 'GIFT_RECIPIENTS_INFORMATION',
    GIFT_RECIPIENTS_INFORMATION_CONTENT = 'GIFT_RECIPIENTS_INFORMATION_CONTENT',
    GIFT_RECIPIENTS_FULL_NAME_FIELD = 'GIFT_RECIPIENTS_FULL_NAME_FIELD',
    GIFT_RECIPIENTS_EMAIL_FIELD = 'GIFT_RECIPIENTS_EMAIL_FIELD',
    LOCATE_MY_GIFT = 'LOCATE_MY_GIFT',
    RETURNING_YOUR_ORDER = 'RETURNING_YOUR_ORDER',
    BXGY_HEADLINE = 'BXGY_HEADLINE',
    BXGY_INSTRUCTIONS = 'BXGY_INSTRUCTIONS',
    BXGY_CUSTOMER_BUYS_HEADLINE = 'BXGY_CUSTOMER_BUYS_HEADLINE',
    BXGY_CUSTOMER_GETS_HEADLINE = 'BXGY_CUSTOMER_GETS_HEADLINE',
    EXCHANGE_PRODUCT_TITLE = 'EXCHANGE_PRODUCT_TITLE',
    SEARCH_INSTRUCTIONS = 'SEARCH_INSTRUCTIONS',
    SEARCH_INSTRUCTIONS_ICON = 'SEARCH_INSTRUCTIONS_ICON',
    BROWSE = 'BROWSE',
    BROWSE_STORE_URL = 'BROWSE_STORE_URL',
    OUR_STORE_FOR_IDEAS = 'OUR_STORE_FOR_IDEAS',
    NO_ADDITIONAL_RESULTS = 'NO_ADDITIONAL_RESULTS',
    NO_ADDITIONAL_RESULTS_ICON = 'NO_ADDITIONAL_RESULTS_ICON',
    NO_ADDITIONAL_RESULTS_SEARCH_AGAIN = 'NO_ADDITIONAL_RESULTS_SEARCH_AGAIN',
    NO_RESULTS = 'NO_RESULTS',
    NO_RESULTS_ICON = 'NO_RESULTS_ICON',
    NO_RESULTS_TRY_AGAIN = 'NO_RESULTS_TRY_AGAIN',
    SEARCH_ERROR = 'SEARCH_ERROR',
    SEARCH_ERROR_ICON = 'SEARCH_ERROR_ICON',
    SEARCH_ERROR_TRY_AGAIN = 'SEARCH_ERROR_TRY_AGAIN',
    SEARCH = 'SEARCH',
    INCLUDED_IN_DISCOUNT = 'INCLUDED_IN_DISCOUNT',
    NOTE_TITLE = 'NOTE_TITLE',
    DISCOUNT_CHOSEN_ITEM_WARNING = 'DISCOUNT_CHOSEN_ITEM_WARNING',
    DISCOUNT_REFUND_WARNING = 'DISCOUNT_REFUND_WARNING',
    DISCOUNT_EXCHANGE_WARNING = 'DISCOUNT_EXCHANGE_WARNING',
    DISCOUNT_MIXED_WARNING = 'DISCOUNT_MIXED_WARNING',
    REMOVED_ITEMS_INFO_NOTE = 'REMOVED_ITEMS_INFO_NOTE',
    YOUR_RETURN_IS_FREE = 'YOUR_RETURN_IS_FREE',
    YOUR_RETURN_IS_FREE_DESCRIPTION = 'YOUR_RETURN_IS_FREE_DESCRIPTION',
}

export enum TRACKING_PORTAL_TRANSLATION_KEYS {
    FIRST_PAGE_TRACKING_CONTENT = 'FIRST_PAGE_TRACKING_CONTENT',
    NO_RESULTS = 'SHIPMENT_NOT_FOUND',
    GENERAL_ERROR_MESSAGE = 'ERROR_FROM_TRACKER',
    SEARCH_ERROR = 'NO_TRACKING_NUMBER',
    PENDING_SHIPMENT = 'PENDING_SHIPMENT',
    TRACKING_DESCRIPTION_PENDING_SHIPMENT = 'TRACKING_DESCRIPTION_PENDING_SHIPMENT',
    LABEL_CREATED = 'LABEL_CREATED',
    TRACKING_DESCRIPTION_LABEL_CREATED = 'TRACKING_DESCRIPTION_LABEL_CREATED',
    SHIPPED = 'SHIPPED',
    TRACKING_DESCRIPTION_SHIPPED = 'TRACKING_DESCRIPTION_SHIPPED',
    OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
    TRACKING_DESCRIPTION_OUT_FOR_DELIVERY = 'TRACKING_DESCRIPTION_OUT_FOR_DELIVERY',
    RECEIVED = 'RECEIVED',
    TRACKING_DESCRIPTION_RECEIVED = 'TRACKING_DESCRIPTION_RECEIVED',
    REJECTED = 'REJECTED',
    TRACKING_DESCRIPTION_REJECTED = 'TRACKING_DESCRIPTION_REJECTED',
    ERROR = 'ERROR',
    TRACKING_DESCRIPTION_ERROR = 'TRACKING_DESCRIPTION_ERROR',
    ESTIMATED_DELIVERY_DESCRIPTION = 'ESTIMATED_DELIVERY_DESCRIPTION',
    TRACKING_PORTAL_TITLE = 'TRACKING_PORTAL_TITLE',
    LETS_TRACK_ORDER = 'LETS_TRACK_ORDER',
    LATEST_UPDATE = 'LATEST_UPDATE',
    DETAILS = 'DETAILS',
    SHIPMENT_CONTENT = 'SHIPMENT_CONTENT',
    HISTORY = 'HISTORY',
    SHIPMENT_NOT_FOUND_DESCRIPTION = 'SHIPMENT_NOT_FOUND_DESCRIPTION',
    TRACKING_ERR_SHIPMENT_NOT_FOUND_HYPERLINK = 'TRACKING_ERR_SHIPMENT_NOT_FOUND_HYPERLINK',
    NO_TRACKING_NUMBER = 'NO_TRACKING_NUMBER',
    NO_TRACKING_NUMBER_DESCRIPTION = 'NO_TRACKING_NUMBER_DESCRIPTION',
    ORDER_CANCELLED = 'ORDER_CANCELLED',
    ORDER_CANCELLED_DESCRIPTION = 'ORDER_CANCELLED_DESCRIPTION',
    TRACKING_ERR_ORDER_CANCELLED_HYPERLINK = 'TRACKING_ERR_ORDER_CANCELLED_HYPERLINK',
    TRACKING_ERR_GENERAL_ERROR_HYPERLINK = 'TRACKING_ERR_GENERAL_ERROR_HYPERLINK',
    TRACKING_ERR_TRACKING_NOT_FOUND_HYPERLINK = 'TRACKING_ERR_TRACKING_NOT_FOUND_HYPERLINK',
    UNFULFILLED_NOTIFICATION_HEADER = 'UNFULFILLED_NOTIFICATION_HEADER',
    UNFULFILLED_NOTIFICATION_DESCRIPTION = 'UNFULFILLED_NOTIFICATION_DESCRIPTION',
    UNFULFILLED_NOTIFICATION_HYPERLINK = 'UNFULFILLED_NOTIFICATION_HYPERLINK'
}